module.exports = __webpack_public_path__ + "img/Blumenwiese-1407@2x.4dee83ae.jpg";